export const getDeeplinkPrefix = () => {
  const scheme = import.meta.env.VITE_SCHEME ?? 'https://';
  const productionUrl = import.meta.env.VITE_VERCEL_PROJECT_PRODUCTION_URL;
  const generatedUrl = import.meta.env.VITE_VERCEL_URL;

  const currentUrl = window.location.href;
  const useProductionUrl = currentUrl.includes(productionUrl);

  return scheme + (useProductionUrl ? productionUrl : generatedUrl);
};
